import { useQuery, useMutation } from '@tanstack/react-query';
import clientPortalAxiosInstance from '../../common/utilities/axios/clientPortalAxiosInstance';
import sleep from 'sleep-promise';


export const useGetClientAccountByIdQuery = ({ clientAccountId }) => {
    return useQuery({
        queryKey: ['getClientAccountByIdQuery', `${clientAccountId}`],
        queryFn: () => {
            // sleep(2000);
            return clientPortalAxiosInstance
                .get(`/User-Profile/clientAccount/${clientAccountId}`)
                .then((res) => {
                    // console.log("gll-dataIn:", res.data)
                    return res.data
                })
        },
        // The query will not execute until the clientAccountId exists
        enabled: !!clientAccountId,
    })
}


/**Mutations */
export const useViewClientAccountListMutation = () => {
    return useMutation({
        mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
            return clientPortalAxiosInstance.post(`/User-Profile/rolebasedclientAccountList `, {
                "LoggedInUserId": loggedInUserId || "",
                "RoleId": roleId || "",
                "IsEnterpriseAdmin": isEnterpriseAdmin
            })
        },
    })
}

export const useCreateClientAccountMutation = () => {
    return useMutation({
        mutationFn: ({ body }) => {
            return clientPortalAxiosInstance.post(`/User-Profile/clientAccount/createClientAccount`, body)
        },
    })
}

/**
 * If you use PUT to upload file then you may use application/octet-stream as Content-Type. If you upload into Amazon S3 storage using multipart/formdata as Content-Type it will make your files (images, pdfs, documents) into text files with http header added on top. This will damage the content of the uploaded file. So use application/octet-stream when uploading binary files with PUT methods.
 */
export const useUploadLogoOfClientAccountMutation = () => {

    return useMutation({
        mutationFn: ({ file }) => {
            /**file is single file and not array of files */

            const formData = new FormData();
            formData.append('file', file)

            return clientPortalAxiosInstance.post(`/client-referral/account/uploadAccountLogo`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
        },
    })
}

export const useUpdateClientAccountByIdMutation = () => {
    return useMutation({
        mutationFn: ({ body, clientAccountId }) => {
            return clientPortalAxiosInstance.put(`/User-Profile/clientAccount/updateClientAccount/${clientAccountId}`, body)
        },
    })
}
export const useDeleteClientAccountByIdMutation = () => {
    return useMutation({
        mutationFn: ({ clientAccountId, isDeleteMode, isClientAccount, isActivateAll }) => {
            return clientPortalAxiosInstance.delete(`/User-Profile/clientAccount/deleteClientAccount/${clientAccountId}`, {
                data: {
                    "IsDeleteMode": isDeleteMode,
                    "IsClientAccount": isClientAccount,
                    "IsActivateAll": isActivateAll
                }
            })
        },
    })
}
